// packages/world-model/src/traits/identity/index.ts

export * from './identityTrait.js';
export * from './identityBehavior.js';
export * from './name-vocabulary.js';
export * from './noun-match.js';